// extracted by mini-css-extract-plugin
export var container = "LegacyUpsell-module__container___W6pAn";